// Load Styles
import '../../../scss/page/service/car-inspection.scss';
import {utility, toggleScrollToSection} from '../../utility.js';

let main_navigation_element = document.getElementById( 'primary-main-navbar' );
let main_navigation_offset_y = main_navigation_element.offsetHeight;

// Your app code
// TOC scroll to
const scrollto_btn_arr = document.querySelectorAll( '[rel="scrollto"]' );

scrollto_btn_arr.forEach( button => {
  button.addEventListener( 'click', function( e ) {
    e.preventDefault();

    let anchor =  e.target.getAttribute( 'href' );
    anchor = e.target.getAttribute( 'href' ).substring( 1, anchor.length  );

    let element = document.getElementById( anchor );

    let bodyRect = document.body.getBoundingClientRect(),
        elemRect = element.getBoundingClientRect(),
        offset   = elemRect.top - ( bodyRect.top + 176 );

    scrollPageTo( offset );
  } );
} );

// Scroll magic
let controller = new ScrollMagic.Controller();

// TOC
let toc_element = document.getElementById( 'table-of-content' );
let toc_sticky_start_trigger = document.getElementById( 'toc-sticky-start-trigger' );
let toc_sticky_end_trigger = document.getElementById( 'toc-sticky-end-trigger' );

let toc_sticky_end_element = document.getElementById( 'definitions' );

toc_sticky_start_trigger.style.top = toc_element.getBoundingClientRect().top + window.scrollY - main_navigation_offset_y + "px";
toc_sticky_end_trigger.style.top =  ( toc_sticky_end_element.getBoundingClientRect().bottom + window.scrollY ) - toc_element.offsetHeight - main_navigation_offset_y + "px";

let toc_sticky_duration = toc_sticky_end_trigger.getBoundingClientRect().top - toc_sticky_start_trigger.getBoundingClientRect().top + 8;

let toc_sticky_trigger_hook = main_navigation_offset_y / window.innerHeight;

let toc_sticky_scene = new ScrollMagic.Scene( { triggerElement: toc_element, triggerHook: toc_sticky_trigger_hook, duration: toc_sticky_duration, pushFollowers: false } )
      .addTo( controller )
      .on( 'enter leave', toc_sticky_event );

// BODY IMAGE
let body_image_element = document.getElementById( 'body-image' );
let body_image_container_element = document.getElementById( 'body-image-container' );
let body_image_sticky_start_trigger = document.getElementById( 'body-image-sticky-start-trigger' );
let body_image_sticky_end_trigger = document.getElementById( 'body-image-sticky-end-trigger' );

let body_image_sticky_starts_element = document.getElementById( 'body-image-sticky-start' );
let body_image_sticky_ends_element = document.getElementById( 'body-image-sticky-end' );

body_image_sticky_start_trigger.style.top = ( body_image_sticky_starts_element.getBoundingClientRect().top + window.scrollY ) + "px";
body_image_sticky_end_trigger.style.top =  ( body_image_sticky_ends_element.getBoundingClientRect().top + window.scrollY ) + "px";

let body_image_sticky_duration = body_image_sticky_end_trigger.getBoundingClientRect().top - ( body_image_sticky_start_trigger.getBoundingClientRect().top + 307 );

let body_image_sticky_trigger_hook = ( main_navigation_offset_y + toc_element.offsetHeight ) / window.innerHeight;

let body_image_sticky_scene = new ScrollMagic.Scene( { triggerElement: body_image_container_element, triggerHook: body_image_sticky_trigger_hook, duration: body_image_sticky_duration, pushFollowers: false } )
      .addTo( controller )
      .on( 'enter leave', body_image_sticky_event );

//
let faq_item_elements = document.querySelectorAll( '.faq-item' );
let dropdown_element = document.querySelector( '#toc-dropdown' );
let faq_controller = new ScrollMagic.Controller();

var toc_element_orig_text = toc_element.querySelector( '.dropdown-choose-topic-text' ).outerText;

faq_item_elements.forEach( function ( element, index ) {
  var title = element.querySelector( '.title' );
  var slug = element.getAttribute( 'id' );

  if ( title !== null ) {
    element.setAttribute( 'data-title', title.outerText );
    element.setAttribute( 'data-order', index );

    var anchor = document.createElement( 'a' );
    anchor.classList.add( 'toggle-scroll-to-section' );
    anchor.textContent = title.outerText;
    anchor.setAttribute( 'data-section', slug );
    anchor.setAttribute( 'href', '#' + slug );

    var dropdown_item = document.createElement( 'li' );
    dropdown_item.classList.add( 'dropdown-item' );
    dropdown_item.appendChild( anchor );

    dropdown_element.appendChild( dropdown_item );

    let table_of_content_element = document.getElementById( 'table-of-content' );

    let faq_element_hook = ( main_navigation_offset_y + table_of_content_element.offsetHeight ) / window.innerHeight;

    var faq_element_duration = element.offsetHeight;

    var faq_element_scene = new ScrollMagic.Scene( { triggerElement: element, duration: faq_element_duration, triggerHook: faq_element_hook } )
                        .addTo( faq_controller )
                        .on( 'enter leave', faq_element_event );
  }
} );

toggleScrollToSection( main_navigation_offset_y + toc_element.offsetHeight - 4 );

// EVENTS
function toc_sticky_event( e ) {
  if ( e.type == "enter" && e.scrollDirection == "FORWARD" ) {
    toc_element.classList.add( 'active' );

    toc_sticky_scene.setPin( toc_element, {pushFollowers: false} );

  } else if ( e.type == "leave" && e.scrollDirection == "REVERSE" ) {
    toc_element.classList.remove( 'active' );

    toc_sticky_scene.removePin( true );

  }
}

function body_image_sticky_event( e ) {
  if ( e.type == "enter" && e.scrollDirection == "FORWARD" ) {
    body_image_sticky_scene.setPin( body_image_container_element, {pushFollowers: false} );

  } else if ( e.type == "leave" && e.scrollDirection == "REVERSE" ) {
    body_image_sticky_scene.removePin( true );

  }
}

function faq_element_event( e ) {
  var order = e.target.triggerElement().getAttribute( 'data-order' );
  let toc_text_element = toc_element.querySelector( '.dropdown-faq-title-text' );

  if ( ( e.type == "leave" && e.scrollDirection == "REVERSE" && order == 0 ) || ( e.type == "leave" && e.scrollDirection == "FORWARD" && order == ( faq_item_elements.length - 1 ) ) ) {
    toc_text_element.textContent = toc_element_orig_text;

  } else {
    if ( e.type == "enter" ) {
      var text = e.target.triggerElement().getAttribute( 'data-title' );
      toc_text_element.textContent = text;
    }
  }
}

utility();